// removed by extract-text-webpack-plugin
module.exports = {"button":"button--059f6","buttonContent":"buttonContent--16f8a","listItemText":"listItemText--28fcc","icon":"icon--de524"};